import { gql } from '__generated__';

export default gql(`
  query GetCoupons($project_id: ID!, $event_id: ID!, $search: String) {
    project(id: $project_id) {
      id
      event(id: $event_id) {
        id
        active
        coupons(search: $search) {
          id
          prefix
          type
          value
          codes_count
          uses
          max_uses
          start_date
          end_date
          available
          active
          deletable
        }
      }
    }
  }
`);
